import React, { useState, useEffect } from 'react';
import './email-submission-form.sass';
import { Input, InputStyle } from '../../../../components/interface/input/input';
import {
  CheckboxAlign,
  CheckboxStyle,
  InputCheckbox
} from '../../../../components/interface/input/checkbox/input-checkbox';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import { useFormik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';

const FormSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Za krótkie!')
    .max(20, 'Za długie!')
    .required('Pole wymagane'),
  email: Yup.string().email('Email nieprawidłowy').required('Pole wymagane'),
  marketingPermission: Yup.boolean().oneOf([true], 'Pole wymagane'),
  privacyPolicy: Yup.boolean().oneOf([true], 'Pole wymagane'),
});

const options = {
  method: 'POST',
  url: 'https://1yiduq1u84.execute-api.eu-central-1.amazonaws.com/default/collect-email-post',
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json'
  },
  data:{}
};

export const EmailSubmissionForm = () => {

  const [formSubmit, setFormSubmit] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      marketingPermission: false,
      privacyPolicy: false,
    },
    validationSchema: FormSchema,
    onSubmit: (values) => {
      options.data = {email: values.email, firstName: values.name};
      axios.request(options)
        .then(() => {
          setFormSubmit(true);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({'event':'formSubmitted'});
        });
    }
  });

  return !formSubmit ? (
      <div className='vv-email-submission-form-container'>
        <form onSubmit={formik.handleSubmit}>
          <Input label='Imię:' onBlur={formik.handleBlur} onChange={formik.handleChange} name='name'
                 id='name' value={formik.values.name}
                 textError={formik.touched.name && formik.errors.name}
                 inputStyle={InputStyle.UNIQUE_LANDING_PAGE}/>
          <Input label='Mejl:' onBlur={formik.handleBlur} onChange={formik.handleChange} name='email'
                 id='email' value={formik.values.email}
                 textError={formik.touched.email && formik.errors.email}
                 inputStyle={InputStyle.UNIQUE_LANDING_PAGE}/>
          <div className='vv-email-submission-form-container__checkbox-container'>
            <div className='vv-checkbox-margin'>
              <InputCheckbox
                label='Wyrażam zgodę na otrzymywanie informacji handlowej w formie newslettera przesyłanego na podany przeze mnie adres e-mail.'
                onChange={formik.handleChange}
                link={'https://docs.google.com/document/d/1KnKsJ9cxoKzwA_JWA-cMPZW98sCV58Uq/edit'}
                name='marketingPermission' id='marketingPermission'
                value={formik.values.marketingPermission}
                textError={formik.touched.marketingPermission && formik.errors.marketingPermission}
                style={CheckboxStyle.UNIQUE_LANDING_PAGE} className='vv-checkbox-margin'
                align={CheckboxAlign.TOP}/>
            </div>
            <InputCheckbox label='Polityka prywatnosci' onChange={formik.handleChange}
                           link={'https://docs.google.com/document/d/1qbdi8EDXtROOA8-VAYliw_decdamr7wb/edit'}
                           name='privacyPolicy' id='privacyPolicy'
                           value={formik.values.privacyPolicy}
                           textError={formik.touched.privacyPolicy && formik.errors.privacyPolicy}
                           style={CheckboxStyle.UNIQUE_LANDING_PAGE}/>
          </div>
          <Button size={ButtonSize.LANDING} buttonType={ButtonType.YELLOW} type='submit'
                  text='ZAPISZ SIĘ'/>
        </form>
      </div>)
    :
    <div className='vv-email-submission-form-container vv-email-submission-form-container--sent'>
      <h2>Formularz wysłany!</h2>
      <p>Będziemy w kontakcie</p>
    </div>;
};
